// Route constants for the application
// This ensures type safety and prevents typos in route paths

export const ROUTES = {
  // Public routes
  HOME: '/',
  PRICING: '/pricing',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  TERMS_OF_SERVICE: '/terms-of-service',
  PRIVACY_POLICY: '/privacy-policy',
  
  // Protected routes
  DASHBOARD: '/app/dashboard',
  CHILDREN: '/app/children',
  CHILD_DETAIL: '/app/children/:id',
  CHILD_NEW: '/app/children/new',
  ASSESSMENTS: '/app/assessments',
  ASSESSMENTS_NEW: '/app/assessments/new',
  ASSESSMENT_SCORING: '/app/assessments/:id/scoring',
  ASSESSMENT_SUMMARY: '/app/assessments/:id/summary',
  REPORTS: '/app/reports',
  SETTINGS: '/app/settings',
  
  // Fallback
  NOT_FOUND: '*',
} as const;

// Helper function to build dynamic routes
export const buildRoute = {
  childDetail: (id: string) => `/app/children/${id}`,
  assessmentScoring: (id: string) => `/app/assessments/${id}/scoring`,
  assessmentSummary: (id: string) => `/app/assessments/${id}/summary`,
  newAssessment: (childId?: string) => 
    childId ? `/app/assessments/new?child=${childId}` : '/app/assessments/new',
} as const;

export type RoutePath = typeof ROUTES[keyof typeof ROUTES];
